<template>
  <div class="course-action-add-page">
    <div class="main_r">
      <div class="page-top">
        <div class="title_line">添加动作到课程</div>
        <div class="filter-strip">
          <div class="filter-strip__fields">
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">动作分类</label>
              <el-select v-model="queryData.actionType" placeholder="动作分类" size="small">
                <el-option label="动作分类" value="0"></el-option>
                <el-option
                  v-for="item in aptustwoGvListActionType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">部位分类</label>
              <el-select v-model="queryData.bodyType" placeholder="部位分类" size="small">
                <el-option label="部位分类" value=""></el-option>
                <el-option
                  v-for="item in aptustwoGvListBodyType" :key="item.gv" :label="item.name" :value="item.gv">
                </el-option>
              </el-select>
            </div>
            <div class="filter-field filter-field--compact">
              <label class="filter-field__label">动作名称</label>
              <el-input v-model="queryData.actionName" placeholder="请输入动作名称" clearable size="small"></el-input>
            </div>
          </div>
          <div class="filter-strip__actions">
            <el-button type="primary" size="small" icon="el-icon-back" @click="clickBack">返回</el-button>
            <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
            <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
          </div>
        </div>
      </div>

      <div class="table-section">
        <div class="table-container" ref="tableContainer" :class="{ 'has-scroll': tableHasScroll }">
          <el-table
            :data="dataList"
            :height="tableHeight"
            class="course-action-add-table"
            :header-cell-style="tableHeaderStyle"
            :cell-style="tableCellStyle"
            @sort-change="handleSortChange"
          >
            <el-table-column prop="id" label="序号" width="80" sortable="custom" align="center"></el-table-column>
            <el-table-column prop="actionTypeUi" label="动作分类" sortable="custom" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bodyTypeUi" label="部位分类" sortable="custom" min-width="110" show-overflow-tooltip></el-table-column>
            <el-table-column prop="actionName" label="动作名称" sortable="custom" min-width="140" show-overflow-tooltip></el-table-column>
            <el-table-column label="动作列表封面" width="110" align="center">
              <template v-slot="scope">
                <img :src="scope.row.actionIconUi" class="action-cover" alt="" />
              </template>
            </el-table-column>
            <el-table-column prop="actionTime" label="动作时长" sortable="custom" width="100" align="center">
              <template slot-scope="props">
                {{ props.row.actionTime }}秒
              </template>
            </el-table-column>
            <el-table-column label="动作视频" width="90" align="center">
              <template v-slot="scope">
                <el-link :underline="false" type="primary" :href="scope.row.actionVideoUrlUi" target="_blank">视频</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable="custom" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="Operation" label="操作" width="80" align="center">
              <template slot-scope="scope">
                <div class="action-group">
                  <el-tooltip effect="dark" content="添加" placement="top" :enterable="false">
                    <el-link :underline="false" type="primary" icon="el-icon-plus" @click="ClickInsert(scope.row)"></el-link>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[5, 10, 15, 20]"
          :page-size="page_size"
          layout="total, prev, pager, next, sizes, jumper"
          :total="dataListnum">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="添加动作到课" :visible.sync="dialogInsert" width="20%" class="confirmDel">
      <div class="confirmMsg">确定添加这个动作到课程吗？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="CourseActionInsert">确定</el-button>
        <el-button @click="dialogInsert = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: { },
  data () {
    return {
      formLabelWidth: '120px',
      aptustwoGvListActionType: [],
      aptustwoGvListBodyType: [],
      aptustwoGvListMuscleRoup: [],
      aptustwoGvListAccessories: [],
      queryData: {
        actionType: '0',
        bodyType: '',
        actionName: ''
      },
      dataList: [],
      dataListnum: 0,
      page_no: 1,
      page_size: 5,
      sortField: '',
      sortOrder: '',
      insertForm: {
        sort: '0',
        courseId: '0',
        actionId: '0'
      },
      dialogInsert: false,
      tableHasScroll: false,
      tableHeight: 480,
      tableResizeObserver: null
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
  },
  mounted () {
    window.addEventListener('resize', this.onWindowResize)
  },
  methods: {
    tableHeaderStyle () {
      return {
        textAlign: 'center',
        background: '#F5F6F8',
        color: '#5E6670',
        fontWeight: '600'
      }
    },
    tableCellStyle ({ column }) {
      if (column.property === 'Operation' || column.property === 'id' || column.property === 'actionTime' || column.label === '动作列表封面' || column.label === '动作视频') {
        return { textAlign: 'center' }
      }
      return { textAlign: 'left' }
    },
    checkTableScroll () {
      var that = this
      this.$nextTick(function () {
        var el = that.$refs.tableContainer
        if (!el) return
        var bodyWrapper = el.querySelector('.el-table__body-wrapper')
        var target = bodyWrapper || el
        that.tableHasScroll = target.scrollWidth > target.clientWidth + 2
      })
    },
    calcTableHeight () {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
        that.checkTableScroll()
      })
    },
    initTableResizeObserver () {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.destroyTableResizeObserver()
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver () {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize () {
      this.calcTableHeight()
    },
    LoadData (courseId) {
      this.insertForm.courseId = courseId
      this.aptustwoGvListActionType = JSON.parse(localStorage.getItem('aptustwoGvListActionType'))
      this.aptustwoGvListBodyType = JSON.parse(localStorage.getItem('aptustwoGvListBodyType'))
      this.aptustwoGvListMuscleRoup = JSON.parse(localStorage.getItem('aptustwoGvListMuscleRoup'))
      this.aptustwoGvListAccessories = JSON.parse(localStorage.getItem('aptustwoGvListAccessories'))
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
      this.$nextTick(this.initTableResizeObserver)
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.page_no = 1
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    handleSizeChange (val) {
      this.page_size = val
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    handleCurrentChange (val) {
      this.page_no = val
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    clickQuery () {
      this.page_no = 1
      this.ActionDatabaseList()
      this.ActionDatabaseNum()
    },
    clickBack () {
      this.$emit('triggerFunc', '')
    },
    clickQueryReset () {
      this.queryData.actionType = '0'
      this.queryData.bodyType = ''
      this.queryData.actionName = ''
      this.clickQuery()
    },
    ClickInsert (row) {
      this.dialogInsert = true
      this.insertForm.actionId = row.id
    },
    ActionDatabaseList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = that.queryData.actionType
      data.bodyType = that.queryData.bodyType
      data.actionName = that.queryData.actionName
      data.pageNo = that.page_no
      data.pageSize = that.page_size
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.calcTableHeight()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    ActionDatabaseNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.actionType = that.queryData.actionType
      data.bodyType = that.queryData.bodyType
      data.actionName = that.queryData.actionName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_ActionDatabaseNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    CourseActionInsert: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sort = that.insertForm.sort
      data.courseId = that.insertForm.courseId
      data.actionId = that.insertForm.actionId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_CourseActionInsert, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindAllways(response.data)
          if (response.data.code === 1) {
            Vue.prototype.$message.success('添加成功')
            that.dialogInsert = false
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.course-action-add-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-danger-bg: #FDECEC;

  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field--compact {
  gap: 4px;

  /deep/ .el-input,
  /deep/ .el-select {
    width: 100%;
  }
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;

  &.has-scroll::after {
    content: '';
    position: absolute;
    top: 40px;
    right: 0;
    bottom: 0;
    width: 24px;
    background: linear-gradient(to right, transparent, rgba(255, 255, 255, 0.95));
    pointer-events: none;
    z-index: 4;
  }
}

.course-action-add-table {
  /deep/ .el-table__body td {
    padding: 10px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

.action-cover {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  object-fit: cover;
  border: 1px solid var(--aptus-border-light);
}

.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: var(--aptus-primary);
}

@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }
}
</style>
